(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/components/duration-selection.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/components/duration-selection.js');

'use strict';

const {
  useContext,
  useEffect
} = React;
const {
  RadioGroup,
  RadioButton
} = svs.ui.reactForm;
const {
  PROLONG_SUBSCRIPTION
} = svs.numbergames.prolong_game.common.constants;
const {
  getBrandingClass,
  isKeno
} = svs.numbergames.productMapping;
const {
  ProlongContext
} = svs.numbergames.prolong_game.context;
const getPossibleDrawCounts = productId => {
  const rules = svs.numbergames.rules.getRules(productId);
  const possibleDraws = [...rules.possibleDrawCounts];
  if (rules.hasSubscription) {
    return [...possibleDraws, {
      value: PROLONG_SUBSCRIPTION,
      label: 'Prenumerera'
    }];
  }
  return possibleDraws;
};
const DurationSelection = () => {
  const {
    drawCount,
    setDrawCount,
    accountIsSyndicate,
    wager: {
      productName,
      isSyndicate
    }
  } = useContext(ProlongContext);
  const possibleDrawCounts = getPossibleDrawCounts(productName);
  const branding = getBrandingClass(productName);
  const handleRadioButtonChange = newDrawCount => {
    setDrawCount(newDrawCount);
  };

  useEffect(() => {
    var _document$querySelect;
    const subFormEl = (_document$querySelect = document.querySelector('.mg-subscription')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.parentNode;
    if (svs.core.detect.feature('ft-subscription-popup-mybets') && subFormEl && !isSyndicate) {
      const tooltip = document.createElement('div');
      tooltip.className = 'subscription-tooltip';
      tooltip.innerHTML = 'Missa aldrig<br/>en dragning!';
      subFormEl.classList.add('animate-prolong-subscription-radio-btn', branding);
      subFormEl.appendChild(tooltip);
    }
  }, [branding, isSyndicate]);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "padding-v"
  }, isKeno(productName) ? 'Antal speldagar' : 'Spellängd'), React.createElement(RadioGroup, {
    multipleLines: true,
    size: 200
  }, possibleDrawCounts.map(week => React.createElement(RadioButton, {
    branding: branding,
    checked: drawCount.toString() === week.value,
    className: week.value === PROLONG_SUBSCRIPTION ? 'mg-subscription' : '',
    disabled: Boolean(week.value === PROLONG_SUBSCRIPTION && accountIsSyndicate),
    key: week.value,
    minWidth: "".concat(100 / 6, "%"),
    onChange: handleRadioButtonChange,
    value: week.value
  }, week.label))));
};
setGlobal('svs.numbergames.prolong_game.components.DurationSelection', DurationSelection);

 })(window);